import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface PCLInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function PCLInternalControls({
  onBack,
  setActiveSection,
  controlsListSection,
}: PCLInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Provisions & Contingent Liabilities"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}

